import { Typography } from '@mui/material';
import { TypographyProps } from '@mui/material';

// Mirrors every variant defined in src/styles/components/mui-typography-styles.ts.
// The rendered sample uses the real theme variant, so the visual never drifts;
// `size`/`weight` here are shown as reference labels only.
type VariantItem = {
  name: string;
  variant: TypographyProps['variant'];
  size: string;
  weight: number;
  desc: string;
  custom?: boolean;
};

const variants: VariantItem[] = [
  { name: 'H1', variant: 'h1', size: '64px (40px ≤1715px)', weight: 600, desc: 'Main page title' },
  { name: 'H2', variant: 'h2', size: '40px', weight: 600, desc: 'Heading 2' },
  { name: 'H3', variant: 'h3', size: '34px', weight: 600, desc: 'Heading 3' },
  { name: 'H4', variant: 'h4', size: '32px', weight: 600, desc: 'Section title' },
  { name: 'H5', variant: 'h5', size: '30px', weight: 600, desc: 'Heading 5' },
  { name: 'H6', variant: 'h6', size: '28px', weight: 600, desc: 'Small section title' },
  { name: 'Subtitle 1', variant: 'subtitle1', size: '24px', weight: 600, desc: 'Subtitle' },
  { name: 'Subtitle 2', variant: 'subtitle2', size: '22px', weight: 600, desc: 'Subtitle' },
  { name: 'Subtitle 3', variant: 'subtitle3', size: '20px', weight: 600, desc: 'Subtitle', custom: true },
  { name: 'Subtitle 4', variant: 'subtitle4', size: '18px', weight: 600, desc: 'Subtitle', custom: true },
  { name: 'Body 1', variant: 'body1', size: '16px', weight: 400, desc: 'Primary text' },
  { name: 'Body 2', variant: 'body2', size: '14px', weight: 400, desc: 'Secondary text' },
  { name: 'Caption', variant: 'caption', size: '12px', weight: 500, desc: 'Small label text' },
  { name: 'Overline', variant: 'overline', size: '10px', weight: 400, desc: 'Overline / meta text' }
];

function TypographyComponent() {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">Typography</h2>

      {variants.map((item) => (
        <div
          key={item.name}
          className="flex flex-col gap-1 border-b pb-4 last:border-none"
        >
          {/* Label row */}
          <div className="flex items-center justify-between">
            <span className="text-[var(--primary)] font-medium flex items-center gap-2">
              {item.name}
              {item.custom && (
                <span className="text-[10px] uppercase tracking-wide bg-[var(--primary-100)] text-[var(--primary)] px-1.5 py-0.5 rounded">
                  custom
                </span>
              )}
            </span>
            <span className="text-gray-400 text-sm">
              {item.size} · {item.weight} · {item.desc}
            </span>
          </div>

          {/* Typography Preview */}
          <div className="bg-gray-50 px-6 py-2.5 rounded-xl border">
            <Typography variant={item.variant}>Hotel Smarters</Typography>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TypographyComponent;
